import { Options, Vue } from 'vue-class-component';

@Options({
	name: 'CheckboxComponent',
	props: {
		name: String,
		id: String,
		inputValue: { type: String, default: undefined },
		preSelect: String,
		disabled: { type: Boolean, default: false },
		change: Boolean,
		visibleError: Boolean,
		validationErrorText: String,
		label: String,
		postLabel: String,
		tooltip: String,
		checkedValue: { type: String, default: undefined },
		unCheckedValue: { type: String, default: undefined },
	},
})
export default class CheckboxComponent extends Vue {
	name: string;
	id: string;
	inputValue?: string; // field.id
	preSelect?: string;
	disabled: boolean;
	change: boolean = false;
	visibleError: boolean;
	validationErrorText: string;
	label: string;
	tooltip: string;
	postLabel: string;
	checkedValue?: string;
	unCheckedValue?: string;
	public hoverCheckField = false;

	// KLK Valid true/false aliases (i.e 'Y'/'N') should be possible to set
	private useAliasStringValues = false;

	// LIFECYCLE
	public created() {
		if (this.checkedValue && this.unCheckedValue) {
			this.useAliasStringValues = true;
		}
		if (this.preSelect) {
			const upper = this.preSelect.toUpperCase().trim();
			if (upper === 'TRUE' || upper === this.checkedValue) {
				this.change = true;
			}
		}
	}

	public get showError() {
		return this.visibleError && !this.change;
	}

	// METHODS
	public changeItem() {
		this.change = !this.change;
		const item = (this as any).$refs[this.name + this.id];
		(item as HTMLInputElement).checked = this.change;
		this.changed();
	}

	public changed() {
		let translatedValue: string;
		if (this.useAliasStringValues) {
			translatedValue = this.change ? this.checkedValue : this.unCheckedValue;
		}

		(this as any).$emit('CheckboxComponent', {
			name: this.name,
			id: this.id,
			translatedValue,
			value: this.inputValue !== undefined ? this.inputValue : this.change,
			checked: this.change,
		});
		(this as any).$refs[this.name + this.id].blur();
	}
}
